import { useMemo } from 'react';
import { CampaignCode, normalizeAddress } from './types';
import { useClaimedStatusByCampaign } from './useClaimedStatusByCampaign';
import { getCampaigns, getUserParticipations, UserParticipation } from './utils';
import { useAccount } from 'wagmi';

type ClaimableParticipations = Partial<Record<CampaignCode, UserParticipation>>;
export function useClaimableParticipations(): ClaimableParticipations {
  const claimedByChain = useClaimedStatusByCampaign();
  const { address } = useAccount();

  const result = useMemo(() => {
    if (!address) return {};
    const proofsByCode = getCampaigns().reduce<ClaimableParticipations>((acc, campaign) => {
      const campaignCode = campaign.root.week_to_campaign_mapping.code;
      const entry = getUserParticipations(normalizeAddress(address), campaignCode)[0];
      if (entry && !claimedByChain.claimedByCampaign[campaignCode]) {
        acc[campaignCode] = entry;
      }
      return acc;
    }, {});
    return proofsByCode;
  }, [address, claimedByChain.claimedByCampaign]);
  return result;
}
